/**
 * Canonical Zustand store example for Adva.
 *
 * See docs/adr/0038-zustand-for-client-state.md for when to use Zustand vs
 * Context vs useState. Keep new stores tight; this one is the reference shape.
 */
import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

interface SidebarState {
  open: boolean;
  setOpen: (open: boolean) => void;
  toggle: () => void;
}

export const useSidebarStore = create<SidebarState>()(
  persist(
    (set) => ({
      open: true,
      setOpen: (open) => set({ open }),
      toggle: () => set((state) => ({ open: !state.open })),
    }),
    {
      name: "adva-sidebar-state",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
